export default __webpack_public_path__ + "static/media/right-mobile-green.4a3b1899.svg";